import { render } from "./ReplyCommentArea.vue?vue&type=template&id=cac26b52&scoped=true"
import script from "./ReplyCommentArea.vue?vue&type=script&lang=js"
export * from "./ReplyCommentArea.vue?vue&type=script&lang=js"

import "./ReplyCommentArea.vue?vue&type=style&index=0&id=cac26b52&scoped=true&lang=css"

import exportComponent from "/Users/yangyu/go/go-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cac26b52"]])

export default __exports__